import axios from 'axios'

export default {
  install (vue) {
    const instance = axios.create({
      // Prefer runtime config.js in deployed Cloud Run; fall back for local/.env builds.
      baseURL: (typeof config !== 'undefined' && config && config.VUE_APP_ENV_BASE_URL)
        ? config.VUE_APP_ENV_BASE_URL
        : (process.env.VUE_APP_API_URL || 'http://localhost:8000'),
    })
    vue.prototype.$http = instance
  },
}
